import React from "react";
import { Container, Dot, H1, H3, Label } from "../../Styles/Global.Styled";
import { PiFlowerFill } from "react-icons/pi";
import { findMatchRGB } from "../../helpers/utilis";
import { css } from "styled-components";

const cntStyle = css`
  flex-direction: column;
  gap: 0.7vh;
  flex-grow: 1;
`;
const h3Style = css`
  font-size: 2vh;
  margin: 1.5vh 0 0;
  color: ${({ theme }) => theme.secColor};
`;
const alignCenter = css`
  align-items: center;
`;
const h1Style = css`
  font-size: 3.5vh;
  width: 100%;
  /* margin-bottom:.5vh; */
`;
const textAlign = css`
  text-align: center;
`;
const labelKeyStyle = css`
  font-size: 1.5vh;
  width: 15vh;
`;
const fontSize4 = css`
  font-size: 1.75vh;
`;

const productLabel = (key, value) => (
  <Container key={key} $baseStyle={alignCenter}>
    <Dot />
    <Label $baseStyle={labelKeyStyle}>{key}</Label>
    <Label $baseStyle={fontSize4}>{value}</Label>
  </Container>
);

const ProductPageLabels = ({ product }) => {
  const matchingRGB = findMatchRGB(product.color);
  const productsSpecs = [
    { label: "Genus", value: product["genus"] },
    { label: "Cultivar", value: product["cultivar"] },
    { label: "Category", value: product["category"] },
    { label: "Origin country", value: product["country_of_origin"] },
    {
      label: "Color",
      value: (
        <>
          <PiFlowerFill color={matchingRGB} />
          {product["color"]}
          {product["Main color flower"]}
        </>
      ),
    },
    {
      label: "Height",
      value: `${product.min_length} - ${product.max_length} cm`,
    },
    {
      label: "Diameter",
      value: `${product.min_diameter} - ${product.max_diameter} cm`,
    },
    {
      label: "Leaf size",
      value: `${product.min_leaf_size} - ${product.max_leaf_size} cm`,
    },
  ];

  return (
    <Container $baseStyle={cntStyle}>
      <H1 $baseStyle={h1Style} $mStyle={textAlign}>
        {product.product_name}
      </H1>
      <H3 $baseStyle={h3Style}>Product Information</H3>
      {productsSpecs.map((productAttr) =>
        productLabel(productAttr.label, productAttr.value)
      )}
      <H3 $baseStyle={h3Style}>Additional details</H3>
      {Object.entries(product.additional_details).map(([key, value]) =>
        productLabel(key, value)
      )}
    </Container>
  );
};

export default ProductPageLabels;
